<template>
  <div class="text-gray-700">
    <div class="text-lg font-medium p-3 border-b">
      {{ $t('common.versionHistory') }}
    </div>
    <div class="w-full overflow-y-auto hl-hv-ct">
      <HistoryCard
        :item="item"
        :selectedVersion="state.selectedVersion"
        :count="state.count"
        v-for="(item, index) in state.historyList"
        :key="index"
        @click="switchPreview(item)"
      ></HistoryCard>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, watch } from 'vue'
import HistoryCard from './HistoryCard.vue'
import { Item as IItem } from '../../types'
export default defineComponent({
  props: {
    templateId: {
      type: String,
      required: true,
    },
    locationId: {
      type: String,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
  },
  components: { HistoryCard },
  async setup(props, { emit }) {
    const state = reactive({
      historyList: [],
      count: 0,
      selectedVersion: 0,
    })
    getVersionHistory()

    function switchPreview(item: IItem) {
      emit('update:version', item)
      state.selectedVersion = item.id
    }
    async function getVersionHistory() {
      const { data } = await props.service.getVersionHistory({
        id: props.templateId as string,
        locationId: props.locationId as string,
      })
      state.historyList = data
      state.count = data.length
      state.selectedVersion = 0
    }
    watch(
      () => props.templateId,
      () => getVersionHistory()
    )
    return {
      state,
      switchPreview,
    }
  },
})
</script>

<style scoped>
.hl-hv-ct {
  height: calc(100% - 110px);
}
</style>
